// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"TernaryStatusIcon_statusIcon__2eg08","OK":"TernaryStatusIcon_OK__JnrK0","ADEQUATE":"TernaryStatusIcon_ADEQUATE__syTLS","BAD":"TernaryStatusIcon_BAD__3sPq9"};